// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Traffic } from "./traffic";

export class NormalTraffic implements flatbuffers.IUnpackableObject<NormalTrafficT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NormalTraffic {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNormalTraffic(bb: flatbuffers.ByteBuffer, obj?: NormalTraffic): NormalTraffic {
    return (obj || new NormalTraffic()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNormalTraffic(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalTraffic,
  ): NormalTraffic {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NormalTraffic()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  message(): Traffic {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : Traffic.P;
  }

  static startNormalTraffic(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addMessage(builder: flatbuffers.Builder, message: Traffic) {
    builder.addFieldInt16(0, message, Traffic.P);
  }

  static endNormalTraffic(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createNormalTraffic(builder: flatbuffers.Builder, message: Traffic): flatbuffers.Offset {
    NormalTraffic.startNormalTraffic(builder);
    NormalTraffic.addMessage(builder, message);
    return NormalTraffic.endNormalTraffic(builder);
  }

  unpack(): NormalTrafficT {
    return new NormalTrafficT(this.message());
  }

  unpackTo(_o: NormalTrafficT): void {
    _o.message = this.message();
  }

  unpackFields(...fields: string[]): NormalTrafficT {
    const t = new NormalTrafficT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    return t;
  }
}

export class NormalTrafficT implements flatbuffers.IGeneratedObject {
  constructor(public message: Traffic = Traffic.P) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return NormalTraffic.createNormalTraffic(builder, this.message);
  }

  clone(): NormalTrafficT {
    const obj = new NormalTrafficT();
    obj.message = this.message;
    return obj;
  }

  equals(other: NormalTrafficT): boolean {
    if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyNormalTraffic(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
